import { Space, Typography } from "antd";
import styles from "./workflowBoard.module.scss";
import {
  SUB_STATUS_TYPES,
  SubStatusButton,
} from "./subStatusButton/subStatusButton";
import { useStatusTransitions } from "../hooks/useStatusTransitions";
import { usePageFilter } from "../../../../../hooks/usePageFilters";
import { isSameSubStatus } from "../utils";
import { getCandidateStatusKey } from "../../../../../utilities/candidate";

const { Text } = Typography;

export const getSubStatusType = (
  subStatus,
  selectedSubStatus,
  transitionsData,
) => {
  if (subStatus.isActive === false) {
    return SUB_STATUS_TYPES.DISABLED;
  }

  if (!selectedSubStatus) return SUB_STATUS_TYPES.DEFAULT;

  if (isSameSubStatus(subStatus, selectedSubStatus)) {
    return SUB_STATUS_TYPES.SELECTED;
  }

  const key = getCandidateStatusKey(subStatus.statusId, subStatus.id);
  const { incomingSourceIds, outgoingTargetIds } = transitionsData;

  if (incomingSourceIds.has(key)) return SUB_STATUS_TYPES.INCOMING;
  if (outgoingTargetIds.has(key)) return SUB_STATUS_TYPES.OUTGOING;

  return SUB_STATUS_TYPES.DEFAULT;
};

export const WorkflowBoard = ({ statuses, subStatusesById, transitions }) => {
  const [selectedSubStatusId, setSelectedSubStatusId] = usePageFilter(
    "candidate_workflow_board_selected_status",
  );

  const selectedSubStatus = subStatusesById[selectedSubStatusId];

  const subStatusTransitions = useStatusTransitions(
    transitions,
    selectedSubStatus,
    true,
  );

  const selectedStatusToDisplay = subStatusesById[selectedSubStatusId]
    ? selectedSubStatus
    : null;

  const onSubStatusClick = (ss) => {
    const newStatus = isSameSubStatus(selectedSubStatus, ss)
      ? null
      : getCandidateStatusKey(ss.statusId, ss.id);

    setSelectedSubStatusId(newStatus);
  };

  return (
    <div className={styles.workflowBoard}>
      <Space direction="vertical">
        {statuses.map((s) => (
          <div key={s.id} className={styles.statusName}>
            <Text strong>{s.name}</Text>
          </div>
        ))}
      </Space>

      <div className={`${styles.scrollableContent} scrollable-container`}>
        <div className={styles.contentWrapper}>
          <Space direction="vertical" style={{ width: "100%" }}>
            {statuses.map((s) => (
              <div key={s.id} className={styles.statusRow}>
                {s.subStatuses.map((ss) => (
                  <SubStatusButton
                    key={getCandidateStatusKey(ss.statusId, ss.id)}
                    name={ss.name}
                    type={getSubStatusType(
                      ss,
                      selectedStatusToDisplay,
                      subStatusTransitions,
                    )}
                    onClick={() => onSubStatusClick(ss)}
                  />
                ))}
              </div>
            ))}
          </Space>
        </div>
      </div>
    </div>
  );
};
